
export interface BasicRoleDto {
  id?: string;
  name: string;
}
